import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import {
  FormGroup,
  Col,
  ControlLabel,
  FormControl
} from 'react-bootstrap';


const SearchComponent =
({ onChange, id, label, colWidth = 2, searchTerm }) => (
  <div>
    <LocalForm
      id={id}
      onSubmit={onChange}
      onChange={onChange}
      initialState={{ searchTerm: searchTerm || '' }}
    >
      <FormGroup>
        <Col md={colWidth} style={{ 'white-space': 'nowrap' }}>
          <ControlLabel>{label}</ControlLabel>
          <Control.custom
            id="searchterm-input"
            model=".searchTerm"
            component={FormControl}
            className="form-control"
            type="text"
            mapProps={({ modelValue, onChange }) => {
              return {
                value: modelValue,
                onChange: onChange
              };
            }}
          />
        </Col>
      </FormGroup>
    </LocalForm>
  </div>
);

SearchComponent.propTypes =
{
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  colWidth: PropTypes.number,
  searchTerm: PropTypes.string
};

export default SearchComponent;



// WEBPACK FOOTER //
// src/Components/SearchComponent.js